import { isNullOrEmpty, newObj } from "../utils/util";

const INITIAL_STATE = {
    user: {
        code: null,
        name: null,
        email: null,
        token: null,
        vision: '',
        shed: '',
        resource: '',
        resourceLaser: '',
        unit: '',
        dock: '',
        dockObj: {},
        shedObj: {},
        resourceObj: {},
        visions: [],
        culture: 'en',
        printer: {},
        equipment: '',
        equipmentObj: {},
        typePrint: '',
        theme: "",
        languages: [
            { code: 'en', name: 'English' },
            { code: 'pt-BR', name: 'Português' },
            { code: 'it', name: 'Italiano' },
            { code: 'es', name: 'Espanhol' },
        ]
    }
};

export default function userReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_USER': {
            const {
                resource,
            } = state.user;
            const userState = action.user !== null ? action.user : state.user;
            userState.resource = resource;
            userState.languages = state.user.languages;

            return {
                ...state,
                user: userState,
            };
        }
        case 'LOAD_USER':
            return {
                ...state,
                user: state.user,
            };
        case 'SET_USER_VISION': {
            const userState = state.user;
            userState.vision = action.vision;
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_CULTURE': {
            const userState = state.user;
            userState.culture = action.culture;
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_WAREHOUSE': {
            const userState = state.user;
            userState.warehouse = action.warehouse;
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_RESOURCE_LASER': {
            const userState = newObj(state.user);
            userState.resourceLaser = action.config && !isNullOrEmpty(userState.resourceLaser) ? userState.resourceLaser : action.resourceLaser;

            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_RESOURCE': {
            const userState = newObj(state.user);
            userState.resource = action.config && !isNullOrEmpty(userState.resource) ? userState.resource : action.resource;
            userState.resourceObj = action.config && !isNullOrEmpty(userState.resourceObj) ? userState.resourceObj : action.resourceObj;

            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_EQUIPMENT': {
            const userState = newObj(state.user);
            userState.equipment = action.config && !isNullOrEmpty(userState.equipment) ? userState.equipment : action.equipment;
            userState.equipmentObj = action.config && !isNullOrEmpty(userState.equipment) ? userState.equipmentObj : action.equipmentObj;

            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_TYPE_PRINT': {
            const userState = newObj(state.user);
            userState.typePrint = action.config && !isNullOrEmpty(userState.typePrint) ? userState.typePrint : action.typePrint;

            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_DOCK': {
            const userState = newObj(state.user);
            userState.dock = action.config && !isNullOrEmpty(userState.dock) ? userState.dock : action.dock;
            userState.dockObj = action.config && !isNullOrEmpty(userState.dock) ? userState.dockObj : action.dockObj;

            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_SHED': {
            const userState = newObj(state.user);
            userState.shed = action.config && !isNullOrEmpty(userState.shed) ? userState.shed : action.shed;
            userState.shedObj = action.config && !isNullOrEmpty(userState.shed) ? userState.shedObj : action.shedObj;

            return {
                ...state,
                user: userState,
            };
        }
        case 'RESET_RESOURCE_SHED_DOCK': {
            const userState = newObj(state.user);
            userState.dock = '';
            userState.shed = '';
            userState.resource = '';

            userState.dockObj = {};
            userState.shedObj = {};
            userState.resourceObj = {};
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_PRINTER': {
            const userState = newObj(state.user);
            userState.printer = action.config && !isNullOrEmpty(userState.printer) ? userState.printer : action.printer;
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_USER_UNIT': {
            const userState = newObj(state.user);
            userState.unit = action.config && !isNullOrEmpty(userState.unit) ? userState.unit : action.unit;
            return {
                ...state,
                user: userState,
            };
        }
        case 'SET_THEME': {
            const theme = action.theme
            return {
                ...state,
                theme: theme,
            };
        }

        default:
            return state;
    }
}
